import { ViewCacheStates } from '../states';

export const selectBranchSettingsCache = (state: ViewCacheStates) => state.branchSettingsViewCache.branchSettings;
